function eventFormSubmitHook(popupID) {
    const popup = document.getElementById(popupID);
    popup.classList.add('show');
}

document.addEventListener("DOMContentLoaded", function(){

    document.querySelectorAll('.event-popup-close').forEach(function(button) {
        button.addEventListener("click", function () {
            document.querySelectorAll('.event-popup').forEach(function(popup) {
                popup.classList.remove('show');
            });
        });
    });

});
